import {DimensionAsObject, DimensionsAsTuple} from './types';

/**
 * Given the dimensions of a rectangle, fit it to the available dimensions without changing its aspect ratio.
 */
export function fitToAvailableDimensions(
  [availableHeight, availableWidth]: DimensionsAsTuple,
  [height, width]: DimensionsAsTuple
): DimensionAsObject {
  const percentageOfAvailableWidth = width / availableWidth;
  const percentageOfAvailableHeight = height / availableHeight;
  const fitToAvailableHeight =
    percentageOfAvailableWidth > percentageOfAvailableHeight;

  if (fitToAvailableHeight) {
    return {
      width: (availableHeight / height) * width,
      height: availableHeight,
    };
  }
  return {
    width: availableWidth,
    height: (availableWidth / width) * height,
  };
}
